import { render } from "./IndexConfigInterventions.vue?vue&type=template&id=5e0e0be4&scoped=true"
import script from "./IndexConfigInterventions.vue?vue&type=script&lang=js"
export * from "./IndexConfigInterventions.vue?vue&type=script&lang=js"

import "./IndexConfigInterventions.vue?vue&type=style&index=0&id=5e0e0be4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e0e0be4"]])

export default __exports__